import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [state, setState] = useState({ status: "polling", session_id: null, order_number: null });
  const attempts = useRef(0);
  const nav = useNavigate();
  const { clearCart } = useCart();

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState({ status: "error" }); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid" && data.order_number) {
          clearCart();
          setState({ status: "paid", session_id: sid, order_number: data.order_number });
          setTimeout(() => nav(`/order-success/${data.order_number}?guest=1`), 800);
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") {
          setState({ status: "failed" }); return;
        }
      } catch {}
      if (attempts.current > 20) { setState({ status: "timeout", session_id: sid }); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [clearCart, nav]);

  if (state.status === "paid") {
    return (
      <div className="container-x py-24 text-center" data-testid="payment-success">
        <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-600" strokeWidth={1.5} />
        <div className="font-serif text-4xl mt-4">Payment Successful</div>
        <p className="text-muted-foreground mt-2">Redirecting to your order…</p>
      </div>
    );
  }
  if (state.status === "failed" || state.status === "error") {
    return (
      <div className="container-x py-24 text-center" data-testid="payment-error">
        <XCircle className="w-16 h-16 mx-auto text-destructive" strokeWidth={1.5} />
        <div className="font-serif text-4xl mt-4">Payment Failed</div>
        <p className="text-muted-foreground mt-2 mb-6">Your cart is still saved — please try again.</p>
        <button onClick={() => nav("/checkout")} className="btn-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest">Retry Payment</button>
      </div>
    );
  }
  return (
    <div className="container-x py-24 text-center" data-testid="payment-polling">
      <Loader2 className="w-10 h-10 mx-auto animate-spin gold-text" strokeWidth={1.5} />
      <div className="font-serif text-2xl mt-4">Verifying your payment…</div>
      <p className="text-muted-foreground mt-1 text-sm">Please don't close this page.</p>
    </div>
  );
}
